<img class="actionColButton" (click)="btnClickedHandler($event)" src="assets/action_pencil.png"
    mat-icon-button  >